"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgPreviewEmpty = void 0;
// external
const React = require("react");
// local
const Icon_1 = require("../../../Icon");
const standardSizes_1 = require("../../../../../../types/standardSizes");
// css
const imgPreviewStyles = require("../../styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(imgPreviewStyles, "imgPreview");
/**
 * Displays an empty image inside the image preview
 *
 * @example when you need to hint at the user that they should add another photo
 */
const ImgPreviewEmpty = ({ icon = "plus" }) => {
    return (React.createElement("div", { className: css("empty") },
        React.createElement(Icon_1.Icon, { size: standardSizes_1.TStandardSizes.Small, name: icon, className: css("empty_icon") })));
};
exports.ImgPreviewEmpty = ImgPreviewEmpty;
//# sourceMappingURL=index.js.map